<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>菜单添加</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules" >
            <el-form-item label="名称" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="菜单图标" >
                <el-input v-model="form.icons"></el-input>
            </el-form-item>
            <el-form-item label="组件(name)" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="组件(path)" >
                <el-input v-model="form.path"></el-input>
            </el-form-item>
            <el-form-item label="组件" >
                <el-input v-model="form.component"></el-input>
            </el-form-item>
            <el-form-item label="参数" >
                <el-input v-model="form.params"></el-input>
            </el-form-item>

            <el-form-item label="上级菜单">
                <el-select v-model="form.pid" placeholder="上级菜单">
                    <el-option label="无" value="0"></el-option>
                    <el-option :label="item.title" :value="item.id" v-for="(item,index) in cate_data" :key="index"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="状态">
                <el-select v-model="form.state" placeholder="状态">
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否认证">
                <el-select v-model="form.auth" placeholder="是否认证">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="显示状态">
                <el-select v-model="form.isshow" placeholder="显示状态">
                    <el-option label="显示" value="1"></el-option>
                    <el-option label="隐藏" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-button @click="submitForm('form')" >添加</el-button>
        </el-form>
    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      cate_data:[],
      form: {
        title:"",
        name: "",
        pid:"0",
        state:"1",
        path:"",
        component:"",
        icons:"",
        isshow:"1",
        auth:"1",
        params:""

      },

      rules: {
          title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {  message: "请输入名称", trigger: "blur" },
        ],
      },

    };
  },
  methods: {
    ...mapActions({
        addMenuAction: "addMenuAction",
        getMenuIndexAction:"getMenuIndexAction"
    }),

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addMenuAction({
              title: this.form.title,
              name: this.form.name,
              path: this.form.path,

              state: this.form.state,
              pid: this.form.pid,
              icons:this.form.icons,
              isshow:this.form.isshow,
              auth:this.form.auth,
              component:this.form.component,
              params:this.form.params,


          });

            console.log("error submit!!");
        } else {

          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
      this.getMenuIndexAction({ type:0})
  },
    computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.menu.result,
    }),
  },
  watch: {
    result(val) {
      if (val.code == 301) {
        this.$message({
          message: "菜单添加成功",
          type: "success",
        });
      }
        if (val.code == 400) {
            this.$message({
                message: "菜单添加失败",
                type: "warning",
            });
        }
        if(val.code==200){
            this.cate_data=val.data

        }
        this.form.name=""
        this.form.state="1"
        this.form.pid="0"
        this.form.component=""
        this.form.icons=""
        this.form.path=""
        this.form.title=""
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>
